import React from 'react'
import styles from './PageContent.module.css'

export default ({ children }) => {
  return <main className={styles.pageContent}>{children}</main>
}
